export default "__VITE_ASSET__wCjmmdK5__"